/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10.48 12a1.52 1.52 0 1 1 3.041.001A1.52 1.52 0 0 1 10.48 12Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22C6.487 22 2 17.514 2 12S6.487 2 12 2s10 4.486 10 10-4.487 10-10 10Zm2.35-7.048a3.324 3.324 0 0 0 1.364-2.379l.468-4.844c.137-1.418-1.448-2.34-2.6-1.51L9.65 9.047a3.325 3.325 0 0 0-1.364 2.38l-.468 4.843c-.137 1.418 1.448 2.34 2.6 1.51l3.932-2.83Z"
})), "0 0 24 24", "Compass");